import React from 'react';

/**
 * 暂停图标 - 圆形背景带两条竖线
 * 用于视频或音频暂停按钮
 */
const PauseIcon = ({ style, className }) => {
    return (
        <svg 
            viewBox="0 0 1024 1024" 
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="currentColor"
            style={{ 
                display: 'inline-block', 
                verticalAlign: 'middle',
                ...style 
            }}
            className={className}
        >
            <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="currentColor" />
            <path d="M436.087 685.247h-56.26c-6.6 0-12-5.4-12-12V336.794c0-6.6 5.4-12 12-12h56.26c6.6 0 12 5.4 12 12v336.453c0 6.6-5.4 12-12 12zM644.475 685.247h-56.26c-6.6 0-12-5.4-12-12V336.794c0-6.6 5.4-12 12-12h56.26c6.6 0 12 5.4 12 12v336.453c0 6.6-5.4 12-12 12z" fill="#ffffff" />
        </svg>
    );
};

export default PauseIcon;

